import { ExpirationStatusEnum } from "./ExpirationStatusEnum";

export class RequestStatus {
  static SubmittedStatusValue = 'Submitted';
  static DraftStatusValue = 'Draft';
}

export class Request {
  static ProductionEnvironment = 1;
}

export class CDM {
  static JSchemaArrayType = 'array';
  static JSchemaObjectType = 'object';
  static JSchemaStringType = 'string';
  static JSchemaNumberType = 'number';
  static JSchemaIntegerType = 'integer';
  static JSchemaBooleanType = 'boolean';
  static JSchemaNullType = 'null';
  static cdmType1OptionKey = '1';
  static cdmType2OptionKey = '2';
  static IngestionType_Standard = 'Standard';
  static IngestionType_Bulk = 'Bulk';
  static HandshakeType_Default = 'Default';
}
export class RuleSet {
  static ExpressionDelimiter = '|~|';
}

export const reservedSchemaKeys = new Set([
  "$id", 
  "id",
  "items",
  "properties",
  "format",
  "type",
  "description", 
  "required",
]);

export class SCHEMA_KEYS {
  static REQUIRED= 'required';
  static PROPERTIES= 'properties';
  static ITEMS= 'items';
  static ALLOF= 'allOf';
  static ANYOF= 'anyOf';
  static ONEOF= 'oneOf';
  static NOT= 'not';
  static ROOT= 'root';
};

export const ERROR_MESSAGES = {
  INVALID_JSON: (err: unknown) =>
    `Invalid JSON: ${err}`,

  INVALID_JSON_SCHEMA: (message: string) =>
    `Invalid JSON Schema: ${message}`,
  
  MISSING_ID: (path: string) =>
    `At ${path || SCHEMA_KEYS.ROOT}: Missing "$id"`,

  MISSING_TYPE: (path: string) =>
    `At ${path || SCHEMA_KEYS.ROOT}: Missing "type"`,

  REQUIRED_MISSING_IN_PROPERTIES: (path: string, fields: string[]) =>
    `At ${path || 'root'}: Required fields missing in properties: ${fields.join(', ')}`,
  
  MISSING_PROPERTIES_FOR_OBJECT: (path: string) =>
    `At ${path || SCHEMA_KEYS.ROOT}: type includes "object" but "properties" is missing or invalid`,

  MISSING_ITEMS_FOR_ARRAY: (path: string) =>
    `At ${path || SCHEMA_KEYS.ROOT}: type includes "array" but "items" is missing`,

  UNEXPECTED_STRUCTURE_FOR_PRIMITIVE: (path: string, typeList: string[]) =>
    `At ${path || SCHEMA_KEYS.ROOT}: type is "${typeList.join(',')}" but has unexpected "properties" or "items"`,

  INVALID_ID_WITH_SPACES: (path: string) =>
    `At ${ path || SCHEMA_KEYS.ROOT}: "$id" must not contain spaces. Please use a name without spaces.`,

  ENTITY_NAME_ALREADY_EXIST: () =>
    "Entity Name already exists.",

};

export const MAX_NOTES_LENGTH = 25;

export const renewalInProgress = 'Creating renewal draft(s)...';
export const renewalSuccess = 'Renewal Created';
export const renewalSuccessDescription = 'Renewal draft(s) created successfully. Please review and submit them from the Requests list.';
export const renewalError = 'Renewal Failed';
export const renewalErrorDescription = 'Failed to create renewal request. Please try again.';
export const PENDING_STATUSES = ['PendingDataOwner', 'PendingPrivacy', 'PendingApproval', 'Submitted'];

export const TRUNCATED_NOTES = (text: string) => {
  if (text.length > MAX_NOTES_LENGTH) {
    return `${text.substring(0, MAX_NOTES_LENGTH)}...`;
  }
  return text;
};

export class ExpirationUtils {
  static Icons = {
    Active: { iconName: 'SkypeCircleCheck', color: '#107C10' },
    NearingExpiration: { iconName: 'AlertSolid', color: '#F7630C' },
    Expired: { iconName: 'StatusErrorFull', color: '#D13438' }
  };

  static getStatusIcon(statusEnum: number): { iconName: string; color: string }  {
    switch (statusEnum) {
      case ExpirationStatusEnum.Active:
        return ExpirationUtils.Icons.Active;
      case ExpirationStatusEnum.NearingExpiration:
        return ExpirationUtils.Icons.NearingExpiration;
      case ExpirationStatusEnum.Expired:
        return ExpirationUtils.Icons.Expired;
      default:
        return { iconName: 'Unknown', color: '#000000' };
    }
  }

  static getStatusText(statusEnum: number): string {
    switch (statusEnum) {
      case ExpirationStatusEnum.Active:
        return 'Active';
      case ExpirationStatusEnum.NearingExpiration:
        return 'Nearing expiration';
      case ExpirationStatusEnum.Expired:
        return 'Expired';
      default:
        return 'Unknown status';
    }
  }

  static formatDate(dateString: string | Date | null): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    });
  }
}
